module.exports = __webpack_public_path__ + "img/gb6561.prt.acd448b7.jpg";